export default class DatePicker {
	constructor() {
		document.addEventListener('DOMContentLoaded', function() {
			var maxDate = new Date();

			maxDate.setFullYear(maxDate.getFullYear() - 18);

			try {
				datepicker('#dob', {
					formatter: (input, date, instance) => {
						input.value = date.toLocaleDateString();
					},
					startDate: maxDate,
					maxDate: maxDate
				});
			} catch {}
		});
	}
}
